import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { auth, provider } from "../Utils/firebase";

function Login() {
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    auth
      .signInWithPopup(provider)
      .then((result) => {
        // /** @type {firebase.auth.OAuthCredential} */
        // var credential = result.credential;

        // // This gives you a Google Access Token. You can use it to access the Google API.
        // var token = credential.accessToken;
        // // The signed-in user info.
        // const user = result.user;
        // // // ...
        // console.log(user);
        setLoading(false);
        setChecked(false);
      })
      .catch((error) => {
        // Handle Errors here.
        // console.log(error);
        setError(error.message);
        // var errorCode = error.code;
        // var errorMessage = error.message;
        // // The email of the user's account used.
        // var email = error.email;
        // // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential;
        // ...
        setLoading(false);
        setChecked(false);
      });
  };

  const goTo = (url) => {
    if (url === "flipcard") {
      window.location.href = "https://flipcard.xyz";
    } else {
      history.push(url);
    }
  };

  useEffect(() => {
    document.title = "Flipcard - Sign In";
    return () => {
      document.title = "Flipcard";
    };
  }, []);

  return (
    <>
      <div className="box">
        <h2 className="darktextColor textBrand">flipcard.xyz</h2>
        <p className="darktextMuteColor text">Feel free to continue!</p>
        <form name="login-form" onSubmit={handleSubmit}>
          {loading ? (
            <button className="btn-in darktextColor textTitle disable">
              Signing in ...
            </button>
          ) : (
            <button
              className={
                !checked
                  ? "btn-in darktextColor textTitle disable"
                  : "btn-in darktextColor textTitle "
              }
              disabled={!checked}
            >
              Sign in with Google
            </button>
          )}

          <div className="grup-input">
            <label className="wrapper">
              <input
                type="checkbox"
                className="input-checkbox"
                name="agree"
                id="agree"
                onChange={() => setChecked(!checked)}
                checked={checked}
              />
              <div className="darktextColor text check-read">
                {" "}
                I agree with the{" "}
                <u onClick={() => goTo("blog/terms-and-conditions")}>
                  terms and conditions
                </u>
              </div>
            </label>
          </div>
        </form>

        {error ? (
          <div className="reset-pw">
            <span className="text">{error}</span>
          </div>
        ) : null}
        <div className="footer textSmall ">
          <ul>
            <li onClick={() => goTo("flipcard")}>&larr; Home </li>
            <li onClick={() => goTo("blog/about")}>About</li>
          </ul>
          <div>
            <p className="textBold">Established 2021 | Flipcard.xyz</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
